<template>
  <g
    :transform="`translate(${(position.map_x * originalImageWidth)},${(position.map_y * originalImageHeight)})`"
    :class="positionClassList"
  >
    <rect
      :id="`O-rect-${position.id}`"
      class="position"
      @click.stop="selectPosition"
      :width="width"
      :height="height"
      :rx="(position.border_radius * position.width * 100)+'%'"
    ></rect>
    <clipPath :id="`O-clip-${position.id}`">
      <use :xlink:href="`#O-rect-${position.id}`"></use>
    </clipPath>
    <text
      :clip-path="`url(#O-clip-${position.id})`"
      class="position-text"
      dominant-baseline="middle"
      text-anchor="middle"
      :x="(position.width * 50)+'%'"
      :y="(position.height * 53)+'%'"
    >
      <tspan
        :font-size="labelFontSize"
      >
        {{ position.map_name }}
      </tspan>
    </text>
  </g>
</template>

<script>
import * as d3 from 'd3'
import { svgTextFontSize } from '@/utils/svgText'

export default {
  name: 'MapPosition',
  props: {
    position: Object,
    selectedPositionIds: {
      type: Array,
      default: () => []
    },
    mapImageAspectRatio: Number
  },
  data: () => ({
    drag: null,
    originalImageWidth: 1000
  }),
  computed: {
    width: function () {
      return `${(this.position.width * 100)}%`
    },
    height: function () {
      return `${(this.position.height * 100)}%`
    },
    originalImageHeight: function () {
      return this.originalImageWidth * this.mapImageAspectRatio
    },
    positionWidth: function () {
      return this.position.width * this.originalImageWidth
    },
    positionHeight: function () {
      return this.position.height * this.originalImageHeight
    },
    labelFontSize: function () {
      return svgTextFontSize(this.position.map_name, this.positionWidth, this.positionHeight)
    },
    isSelected: function () {
      return this.selectedPositionIds.includes(this.position.id)
    },
    positionClassList: function () {
      return {
        'position-container': true,
        'is-selected': this.isSelected,
        'not-selected-position': !this.isSelected
      }
    }
  },
  methods: {
    selectPosition: function () {
      this.$emit('select-position', { position: this.position })
    },
    handleDrag: function (event) {
      this.$emit('dragged', { position: this.position, x: event.dx, y: event.dy })
    }
  },
  watch: {},
  mounted () {
    this.drag = d3.drag()
      .on('drag', this.handleDrag)

    const element = this.$el
    d3.select(element)
      .call(this.drag)
  }
}
</script>
